<template>
  <div class = "page">
    <common-header />
    <div class="container">
      <p v-if="this.type === 'service'" class="title __fs-24">{{detailData.title}}</p>
      <p v-else-if="this.type === 'topic'" class="title __fs-24">{{detailData.name}}</p>
      <p v-else-if="this.type === 'activity'" class="title __fs-24">{{detailData.title}}</p>
      <div class="label __cor-8 __flex __flex-vc">
        <p class="time">时间：{{detailData.createTime | formatTime('YYYY-MM-DD')}}</p>
      </div>
      <div v-if="this.type === 'service'" class="summary" v-html="detailData.content" @click="showImg($event)"></div>
      <div v-else-if="this.type === 'topic'" class="summary" v-html="detailData.expatiate" @click="showImg($event)"></div>
      <div v-else-if="this.type === 'activity'" class="summary" v-html="detailData.content" @click="showImg($event)"></div>
      <div
        class="imgDolg"
        v-show="imgPreview.show"
        @click.stop="imgPreview.show = false"
      >
      <img @click.stop="imgPreview.show = true" :src="imgPreview.img" />
    </div>
    </div>
  </div>
</template>

<script>
import CommonHeader from '@/views/layout/common-back'
import { building } from '@/agent'

export default {
  components: {
    'common-header': CommonHeader
  },
  data () {
    return {
      id: '',
      detailData: {},
      type: '',
      imgPreview: {
        img: '',
        show: false,
      },
      srcImg: 'https://partydevcloud.oss-cn-hangzhou.aliyuncs.com/platform/common/richtext/image/202105185ab9051a068d4e8f8336a1a1f83b3c60.jpg'
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.FindById()
  },
  methods: {
    // 资讯详情api
    async FindById () {
      let result = {}
      if (this.type === 'service') {
        result = await building.findByIdService(this.id)
      } else if (this.type === 'topic') {
        result = await building.findByIdAdvertisement(this.id)
      } else if (this.type === 'activity') {
        result = await building.findByIdActivity(this.id)
      }
      if (result.code === 100) {
        this.detailData = result.data
      }
    },
    showImg (e) {
      if (e.target.tagName === 'IMG') {
        this.imgPreview.img = e.target.src
        this.imgPreview.show = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.page {
  width: 100%;
  height: 100%;
}
.container {
  padding: $header-height 20px 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.title {
  padding: 47px 0 25px;
  text-align: justify;
  line-height: 36px;
}
.label {
  .source {
    margin-left: 21px;
  }
}
.imgDolg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  #imgDolgClose {
    position: fixed;
    top: 35px;
    cursor: pointer;
    right: 7%;
    font-size: 50px;
    color: white;
  }
  img{
    width: 90%;
    object-fit: contain;
  }
}
.summary {
  margin: 48px auto 35px;
  text-indent: 2em;
  text-align: justify;
  line-height: 24px;
  /deep/ img {
    width: 100%;
    margin: 0 auto;
    display: inline;
    margin-left: -2em;
  }
}
</style>
